module.exports = __webpack_public_path__ + "img/xrpusd.5acb3c2c.png";